import { createAction, createSlice } from "@reduxjs/toolkit";
import { parseBankAccounts } from "@/services/rest/bank-info";

export const bankSlice = createSlice({
  name: "bank",
  initialState: {
    isLoading: true,
    error: null,
    bankAccounts: [],
    customer: {}
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
      if(action.payload){
        state.bankAccounts = [];
        state.customer = {};
        state.error = null;
      }
    },
    setbankData: (state, action) => {
      state.isLoading = false;
      state.bankAccounts = parseBankAccounts(action.payload.actDtls);
      // TODO: Add filter for bank accounts opened via TORUS
      state.customer = action.payload.custDtls?.[0] || {};
      state.error = null;
    },
    setEmptyBankData: (state, action) => {
      state.isLoading = false;
      state.bankAccounts = [];
      state.customer = {};
      state.error = null;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.bankAccounts = [];
      state.customer = {};
      state.error = action.payload;
    },
  },
});

// ACTIONS
export const setBankLoadingAction = createAction("bank/setLoading");
export const setBankDataAction = createAction("bank/setbankData");
export const setEmptyBankDataAction = createAction("bank/setEmptyBankData");
export const setBankErrorAction = createAction("bank/setError");

// REDUCERS
export default bankSlice.reducer;
